import React, { useEffect } from "react";
import { LoggerModule } from "@vlinder-web/logger-module-react";

import { useMachine } from "@xstate/react";
import { createMachine } from "xstate";

import { actions } from "./actions";
import { MACHINE_CONFIG } from "./config";
import { services } from "./services";

export const getLabelPDFContext = React.createContext({});
export let getLabelPDFMachine: any;

const MODULE_NAME = "machines.getLabelPDF";
const log: any = LoggerModule?.getInstance();

export const useSMGetLabelPDF = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  getLabelPDFMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(getLabelPDFMachine);

  return {
    getLabelPDFMachine: getLabelPDFMachine,
    getLabelPDFState: state,
    getLabelPDFSend: send,
  };
};
